var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.stationList,
      "item-text": "StationName",
      "item-value": "Id",
      label: "Station",
      rules: _vm.nullRule,
      "return-object": "",
    },
    model: {
      value: _vm.station,
      callback: function ($$v) {
        _vm.station = $$v
      },
      expression: "station",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }